import { axiosWithAuth } from "../../helpers";

export const webSiteService = { updateWebSiteInformation };

const API_URL = process.env.REACT_APP_API_URL;

function updateWebSiteInformation(applicationId, websiteInformation) {
	const options = {
		method: "POST",
		data: {
			title: websiteInformation?.title,
			url: websiteInformation?.url,
			screenshotUrl: websiteInformation?.screenshotUrl,
			checkedSuccessfully:
				websiteInformation?.isSuccessfully ||
				websiteInformation?.checkedSuccessfully,
		},
		url: `${API_URL}/api/applications/${applicationId}/updateWebSiteInformation`,
	};

	return axiosWithAuth(options);
}
